import { useRef } from "react";

import { useAppNudgeStore } from "@faire/retailer/features/Nudges/useAppNudgeStore";
import { useOpenWithFaireStore } from "@faire/retailer/stores/domain/OpenWithFaireStore";
import { useRetailerStore } from "@faire/retailer/stores/domain/RetailerStore";
import { useMilestone } from "@faire/retailer/stores/domain/useMilestone";

import { useNudge2Progress } from "./components/useNudge2Progress";
import { isPathEligibleForOwFNudge } from "./utils";

const LOW_ON_PAYMENT_TERMS_RATIO = 0.5;

export const useUpsellNudgeEligibility = (pathname?: string) => {
  const [{ isOpenWithFaireNudgeShown }] = useAppNudgeStore([
    "isOpenWithFaireNudgeShown",
  ]);

  const { hasOccurred: hasSeenOpenWithFaireUpsellNudge1 } = useMilestone(
    "OPEN_WITH_FAIRE_UPSELL_NUDGE_1_SEEN"
  );
  const { hasOccurred: hasSeenOpenWithFaireUpsellNudge2 } = useMilestone(
    "OPEN_WITH_FAIRE_UPSELL_NUDGE_2_SEEN"
  );
  const { retailer } = useRetailerStore(["retailer"]);
  const { showOwFEntrypoint } = useOpenWithFaireStore(["showOwFEntrypoint"]);
  const { availableTermsRatio } = useNudge2Progress();
  const hasSeenPreviousNudge =
    hasSeenOpenWithFaireUpsellNudge1 || hasSeenOpenWithFaireUpsellNudge2;

  const nudge1EligibilityAtSessionStart = useRef(
    retailer?.identity_confirmed && retailer.first_order_at
  ).current;

  const isEligibleForUpsellNudge1 =
    showOwFEntrypoint &&
    !hasSeenPreviousNudge &&
    isOpenWithFaireNudgeShown &&
    isPathEligibleForOwFNudge(pathname) &&
    nudge1EligibilityAtSessionStart;

  const isEligibleForUpsellNudge2 =
    showOwFEntrypoint &&
    !hasSeenOpenWithFaireUpsellNudge2 &&
    (availableTermsRatio ?? Infinity) < LOW_ON_PAYMENT_TERMS_RATIO &&
    isOpenWithFaireNudgeShown &&
    isPathEligibleForOwFNudge(pathname, { isNudge2: true });

  return {
    isEligibleForUpsellNudge1,
    isEligibleForUpsellNudge2,
    availableTermsRatio,
  };
};
